import {ReferralsPage} from './components';

export default ReferralsPage;
